import * as React from 'react';
import TimelineComponent from "../patient-timeline/patient-timeline";


 const PatientRegistration = ()=> {
  return (
    <TimelineComponent />
  );
}
export default PatientRegistration